import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import { connect } from "react-redux";
import { newFacilityRequest, makeNewRequestStatus } from "../../services/patient/action";
import { NavLink } from "react-router-dom";

import $ from 'jquery';
import { footer } from "../../components/footerSize";
import ThanksModel from '../common/Model/thanksModel';
import {  onlyNumbers} from "../common/keyValidation"

class PatientNewRequest extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            access_token: "",
            doctorName: "",
            facilityName: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            email: "",
            officeEmail: "",
            mobile: "",
            fax: "",
            userId: "",
            dateOfBirth: "",
            website: "",
            openPopUp: false,
            errors: {
                doctorName: "",
                facilityName: "",
                address: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                email: "",
                officeEmail: "",
                mobile: "",
                fax: "",

            },
            formValid: false,
            doctorNameValid: false,
            facilityNameValid: false,
            addressValid: false,
            address2Valid: false,
            cityValid: false,
            stateValid: false,
            zipValid: false,
            officeEmailValid: false,
            mobileValid: false,
            faxValid: false,
            stateList: [],


        }
    }


    validateField(fieldName, value) {
        const {
            errors,
            doctorNameValid,
            facilityNameValid,
            addressValid,
            address2Valid,
            cityValid,
            stateValid,
            zipValid,
            officeEmailValid,
            mobileValid,
            faxValid,


         } = this.state;

        let fieldValidationErrors = errors;
        let doctorNamevalid = doctorNameValid;
        let facilityNamevalid = facilityNameValid;
        let officeEmailvalid = officeEmailValid;
        let mobilevalid = mobileValid;

        let faxvalid = faxValid;

        let addressvalid = addressValid;
        let address2valid = address2Valid;
        let cityvalid = cityValid;
        let statevalid = stateValid;
        let zipvalid = zipValid;
        // let officePhonevalid = officePhoneValid

        switch (fieldName) {
              case "facilityName":
              facilityNamevalid = !(value.length < 3 || value.length > 20);
              fieldValidationErrors.facilityName = facilityNamevalid
                ? ""
                : "Practise Name should be 3 to 20 characters";
              break;

            case "doctorName":
                doctorNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.doctorName = doctorNamevalid
                    ? ""
                    : "First Name should be 3 to 20 characters";
                break;

            //   case "fax":
            //   faxvalid = value.match(/^\d{10}$/);
            //     fieldValidationErrors.fax = faxvalid
            //       ? ""
            //       : "Please enter valid fax number";
            //     break;

            //   case "officeEmail":
            //     officeEmailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
            //     fieldValidationErrors.officeEmail = officeEmailvalid
            //       ? ""
            //       : " Please enter valid Email Address";
            //     break;
            case "mobile":
                mobilevalid = value.match(/^\d{10}$/);
                fieldValidationErrors.mobile = mobilevalid
                    ? ""
                    : " Please enter valid phone number";
                break;
            case "address":
                addressvalid = !(value.length < 1);
                fieldValidationErrors.address = addressvalid
                    ? ""
                    : "Please enter the address";
                break;

            // case "address2":
            // address2valid = !(value.length < 1);
            // fieldValidationErrors.address2 = address2valid
            // ? "" 
            // : "Please enter the address2";
            // break;

            case "city":
                cityvalid = !(value.length < 1);
                fieldValidationErrors.city = cityvalid
                    ? ""
                    : "Please enter the city";
                break;

            case "state":
                statevalid = !(value.length < 1);
                fieldValidationErrors.state = statevalid
                    ? ""
                    : "Please enter the state";
                break;

            case "zip":
                zipvalid = !(value.length < 1);
                fieldValidationErrors.zip = zipvalid
                    ? ""
                    : "Please enter the zip";
                break;
            default:
                break;
        }


        this.setState(
            {
                errors: fieldValidationErrors,
                doctorNameValid: doctorNamevalid,
                mobileValid: mobilevalid,
                faxValid: faxvalid,
                facilityNameValid: facilityNamevalid,
                officeEmailValid: officeEmailvalid,
                addressValid: addressvalid,
                address2Valid: address2valid,
                cityValid: cityvalid,
                stateValid: statevalid,
                zipValid: zipvalid,
            },
            this.validateForm
        );
    }

    validateForm() {
        const {
            doctorNameValid,
            facilityNameValid,
            
            mobileValid,
            addressValid,
           
            cityValid,
            stateValid,
            zipValid,
           
          } = this.state;
        this.setState({
            formValid:

            doctorNameValid &&
            facilityNameValid &&


            mobileValid &&
            addressValid &&

            cityValid &&
            stateValid &&
            zipValid,


        });
    }

    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
    
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };

    componentDidMount() {

        // onDocumentReady function bind
        $(document).ready(function () {
            footer("#content");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#content");
        });
        let access_token = this.props.loginDetails;
        let userId = this.props.profileDetails.commonUser.userId
        this.setState({
            access_token,
            userId
        })
        this.props.makeNewRequestStatus();

        if (this.props.getByLocationDetails) {
            let data = this.props.getByLocationDetails.stateListObj;
            this.setState({
              stateList: data
            })
          }
    }


    sendNewRequest = (e) => {
        e.preventDefault();
        const {
            access_token,
            userId,
            doctorName,
            facilityName,
            address,
            address2,
            city,
            state,
            zip,
            officeEmail,
            mobile,
            fax,
         } = this.state;
        let payLoad = {
            userId,
            doctorName,
            facilityName,
            address,
            address2,
            city,
            state,
            zip,
            officeEmail,
            mobile,
            fax,
            "email": officeEmail,
            "requestStatus": "requested"
        }



        this.props.newFacilityRequest(access_token, payLoad, );

    }

    componentWillReceiveProps = nextProps => {
     
        if (nextProps.newFacilityStatus) {
            // this.props.history.push("/PatientRecord")
          //  document.body.classList.add('modal-open');

            this.setState({ openPopUp: true })
         
        }

    }

    closePop = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            closePop: false
        })
    }
    confirmOkay = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUp: false
        })
        this.props.history.push("/PatientRequest");

    }
  
    onlytext = (e)=> {
        const re = /[^a-zA-Z0-9 ]/g;
        if (re.test(e.key)) {
            e.preventDefault();
        }
    }

    render() {
        const {
        doctorName,
            facilityName,
            address,
            address2,
            city,
            state,
            zip,
            officeEmail,
            mobile,
            fax,
            errors,
            formValid,
            website,
     } = this.state;

     
        return (
            <>
            <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/PatientHome", }, { "name": "Select a Practice/Doctor", "route": "/PatientRequest", }, { "name": "New Practice Request", "route": "/PatientNewRequest", }]} />

            <div className="content">
                <div className="contentSection" id="content">
                    <div className="container-fluid">

                        <div className="bodyContent">
                            <h3 class="title-text">New Practice Request</h3>
                            <div className="row pat-new-req mt-3">
                                <div className="col-lg-12">
                                    <div class="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>Doctor Name</label><sup>*</sup>
                                                <input type="text" name="doctorName" value={doctorName}  onKeyPress={this.onlytext}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.doctorName}</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>Practice Name</label><sup>*</sup>
                                                <input type="text" name="facilityName" value={facilityName}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.facilityName}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">


                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>Office Email</label>
                                                <input type="text" name="officeEmail" value={officeEmail}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.officeEmail}</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group r-form">
                                                <label>Office Phone</label><sup>*</sup>
                                                <div className="mobile-code">
                                                    <input type="text" name="mobile" value={mobile} maxlength="10"
                                                        onChange={this.handleChange} onKeyPress={onlyNumbers} className="r-phone form-control" />
                                                    <div style={{ color: "red" }}>{errors.mobile}</div>
                                                    <div class="country-code-phone"><label>+1</label></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>Address 1</label><sup>*</sup>
                                                <input type="text" name="address" value={address}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.address}</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>Address 2</label>
                                                <input type="text" name="address2" value={address2}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.address2}</div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>City</label><sup>*</sup>
                                                <input type="text" name="city" value={city}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.city}</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                            {/* <div className="form-group">
                                                <label>State</label> <sup>*</sup>
                                                <input type="text" name="state" value={state}
                                                    onChange={this.handleChange} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.state}</div>
                                            </div> */}

                                        <div className="form-group r-form">

                                        <label for="state">State</label><sup>*</sup>
                                        <select className="form-control" id="state" name="state" value={state} onChange={this.handleChange}>
                                        <option value=""  >State </option>
                                        {this.state.stateList.length > 0 ?
                                            this.state.stateList.map((state, id) => {
                                            return (
                                                <option value={state.name} key={id}>{state.name} </option>
                                            )
                                            }) : <option value="no state found"  > No state found </option>
                                        }
                                        </select>
                                        </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>Zip</label><sup>*</sup>
                                                <input type="text" name="zip" value={zip} maxlength="5"
                                                    onChange={this.handleChange} onKeyPress={onlyNumbers} className="form-control" />
                                                <div style={{ color: "red" }}>{errors.zip}</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group r-form">
                                                <label>Fax</label>
                                                <div className="mobile-code">
                                                    <input type="text" name="fax" value={fax} maxlength="10"
                                                        onChange={this.handleChange} onKeyPress={onlyNumbers} className="r-phone form-control" />
                                                    <div style={{ color: "red" }}>{errors.fax}</div>
                                                    <div class="country-code-phone"><label>+1</label></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>








                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Website</label><sup>*</sup>
                                        <input type="text" name="website" value={website}
                                            onChange={this.handleChange} className="form-control" />

                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 ">
                                        <NavLink to="/PatientRequest"> <button type="button" className="btnDefault">Back
                        </button></NavLink>

                                    </div>
                                    <div className="col-lg-9 col-md-6 col-sm-12 col-xs-12 ">
                                        <button type="button" disabled={!formValid} onClick={this.sendNewRequest} className="btnDefault">Please contact this doctor or medical practice so I can request my records on ePaper Road</button>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ThanksModel header="New Practice Request" text="Thank you. We will contact them so they know you are looking for records using ePaper Road" page="newRequest" status={this.state.openPopUp} confirmOkay={this.confirmOkay} />


            <Footer />
	
            </>
        )
    }
}

const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    newFacilityStatus: state.patientReducer.newFacilityStatus,
    loginDetails: state.commonReducer.loginDetails,
    message: state.commonReducer.message,
    getByLocationStatus: state.patientReducer.getByLocationStatus,
    getByLocationDetails: state.patientReducer.getByLocationDetails,

});
const mapDispatchToProps = dispatch => ({
    newFacilityRequest: (token, payLoad, ) => dispatch(newFacilityRequest(token, payLoad, )),
    makeNewRequestStatus: () => dispatch(makeNewRequestStatus())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientNewRequest);

